import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=23d7bffa&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23d7bffa')) {
      api.createRecord('23d7bffa', component.options)
    } else {
      api.reload('23d7bffa', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=23d7bffa&", function () {
      api.rerender('23d7bffa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2K89EFl6jvOKG/JS/cancellationPolicy.vue"
export default component.exports